import { User } from "./user";

// Prompts that ask something of the user land badly on someone who just arrived, so
// every prompt waits until they have had a few sessions' worth of time with the app.
export function isOldUser(user: User): boolean {
  const joinedAt = user.joinedAt;
  if (joinedAt === undefined) return false;

  const targetDate = new Date(joinedAt.getTime() + threeDaysMs);

  return new Date() > targetDate;
}

const threeDaysMs = 1000 * 60 * 60 * 24 * 3;
